<template>
  <section class="section">
    <header>
      <div class="search-form">
        <input-control v-model="query" placeholder="O que você procura?" @keyup="search()" search preventSearchButton></input-control>
        <a href="@" @click.prevent="clearSearch()">
          <fa :icon="['fal','trash-xmark']" class="icon"></fa>
        </a>
      </div>
    </header>
    <div class="planilhasListWrap" v-if="categorias">
      <ol class="cardList">
        <li>
          <div class="plItemInner">
            <span> ID </span>
            <span> Nome </span>
            <span> Indicador </span>
            <span> Classificação </span>
            <span> Rúbrica </span>
            <span> Tipo </span>
            <span> Instruções </span>
            <span> Perfil Pessoa </span>
            <span> Responsável </span>
            <span></span>
          </div>
        </li>
        <li v-for="categoria in categorias" :key="categoria">
          <card spacing="small">
            <div class="plItemInner">
              <span>
                {{ categoria.idAtividadeCategoria }}
              </span>
              <span class="fixed">
                {{ categoria.descricaoCategoriaAtividade }}
              </span>
              <span>
                {{ categoria.descricaoIndicador }}
              </span>
              <span>
                {{ categoria.descricaoClassificacaoAtividade }}
              </span>
              <span>
                {{ categoria.formulario }}
              </span>
              <span>
                {{ categoria.checklist == 1 ? "Tarefa" : "Atividade" }}
              </span>
              <span :title="categoria.instrucoes">
                {{ categoria.instrucoes ? categoria.instrucoes.substr(0,90) + '...' : '' }}
              </span>
              <span>
                {{ getTipoPessoa(categoria.idPerfilPessoa) }}
              </span>
              <span>
                {{ categoria.funcaoResponsavel }}
              </span>
              <span class="action-wrap">
                <router-link :to="{name: 'Formulários', params: { action: 'editar', id: categoria.idFormulario }}" target="_blank" title="Rubrica">
                  <fa :icon="['fal', 'file-import']"></fa>
                </router-link>
                <a href="#" @click.prevent="selectCategoria(categoria)" title="Editar">
                  <fa :icon="['fal', 'pen-to-square']"></fa>
                </a>
              </span>
            </div>
          </card>
        </li>
      </ol>
    </div>
  </section>
</template>

<script>

export default {
  props: {
    scope: {
      type: Array,
    },
    novo: {
      type: Boolean
    },
    editar: {
      type: Boolean
    }
  },
  watch: {
    scope(value) {
      if (value) {
        this.categorias = value
      }
    },
  },
  data() {
    return {
      categorias: null,
      query: null,
      searchWait: null
    }
  },
  mounted() {
    this.categorias = Object.assign([], this.scope)
    // this.bkp = Object.assign([], this.scope)
    console.log("scope", this.scope)
  },
  methods: {
    getTipoPessoa(tipoPessoa) {
      let pessoa = null
      if ( tipoPessoa == 1 ) {
        pessoa = 'Aluno'
      } else if ( tipoPessoa == 2 ) {
        pessoa = 'Colaborador'
      } else if ( tipoPessoa == 3 ) {
        pessoa = 'Responsável'
      }

      return pessoa
    },
    selectCategoria(categoria) {
      console.log('categoria', categoria)
      this.$emit("onSelectCategoria", categoria)
    },
    toggleNew () {
      this.$emit("onNewCategoria")
    },
    search () {
      if ( this.searchWait ) clearTimeout(this.searchWait)

      if ( this.query && this.query.length >= 1 ) {
        this.searchWait = setTimeout(() => {
          this.categorias = this.scope.filter( a => {
            const perfil = this.getTipoPessoa(a.idPerfilPessoa)

            const nome = a.nome.toLowerCase()
            const perfilPessoa = perfil.toString().toLowerCase()
            const classificacao = a.descricaoClassificacaoAtividade.toString().toLowerCase()
            const id = a.idAtividadeCategoria.toString().toLowerCase()
            const indicador = a.descricaoIndicador ? a.descricaoIndicador.toString().toLowerCase() : ''
            const tipo = a.checklist ? 'tarefa' : ( a.kanban ? 'atividade' : '' )
            const responsavel = a.funcaoResponsavel ? a.funcaoResponsavel.toLowerCase() : ''

            const existNome = nome.includes(this.query.toLowerCase())
            const existPerfil = perfilPessoa.includes(this.query.toLowerCase())
            const existClassificacao = classificacao.includes(this.query.toLowerCase())
            const existID = id.includes(this.query)
            const existIndicador = indicador.includes(this.query.toLowerCase())
            const existTipo = tipo.includes(this.query.toLowerCase())
            const existResponsavel = responsavel.includes(this.query.toLowerCase())

            return existNome || existPerfil || existClassificacao || existID || existIndicador || existTipo || existResponsavel
          })
        }, 200)
      } else if ( !this.query || this.query.length == 0 ) {
        this.clearSearch()
      }
    },
    clearSearch() {
      this.categorias = Object.assign([], this.scope)
      this.query = null
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  margin-bottom: $hmg_mid;

  .search-form {
    max-width: 440px;
    display: flex; align-items: center; align-content: center;
    margin-top: $hmg;

    a {
      margin-left: $hmg_small;
      .icon {
        font-size: 16px;
      }

      &:hover {
        .icon {
          color: $color-primary
        }
      }
    }
  }

  h4 {
    margin: 0; padding: 0;
  }
}
.section {
  padding: $hmg_mid;
}
.plItemInner {
  grid-template-columns: 0.3fr 2fr 1.5fr 1.5fr 1.5fr 1fr 2.5fr 1fr 1.5fr 0.5fr;

  span {
    padding: 0 $mg_mini;

    &:first-child {
      padding-left: 0
    }
    &:last-child {
      padding-right: 0
    }
  }
}

.action-wrap {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
  gap: $hmg_mid;
  font-size: 16px;
}
</style>
